module.exports = ".not-paid {\n  color: red; }\n\n.paid {\n  color: green; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/projects/project-cost-income/project-cost-income.component.scss
// module id = ./src/app/views/projects/project-cost-income/project-cost-income.component.scss
// module chunks = main